/**
 * The live configuration the user manipulates (`Configuration`) plus
 * the slider ranges and defaults.
 */
export type Units = "metric" | "imperial";

/** The five numeric configuration fields driven by the sliders. */
export type NumericField =
  | "pilotWeight_kg"
  | "waterBallast_kg"
  | "bugsPercent"
  | "macCready_ms"
  | "windHeadwind_kmh";

export type Configuration = {
  readonly gliderId: string;
  readonly pilotWeight_kg: number; // 60–110
  readonly waterBallast_kg: number; // 0–glider.maxBallast_kg (see RANGES note)
  readonly bugsPercent: number; // 0–30
  readonly macCready_ms: number; // 0–5
  readonly windHeadwind_kmh: number; // signed; + = headwind
  readonly units: Units;
};

/**
 * Slider bounds, in internal units (kg, km/h, m/s).
 *
 * `waterBallast_kg.max` is a database-wide ceiling used only to clamp a decoded
 * URL; the live slider caps at the selected glider's placarded `maxBallast_kg`
 * (the heaviest in the DB is 310 kg).
 */
export const RANGES = {
  pilotWeight_kg: { min: 60, max: 110, step: 1 },
  waterBallast_kg: { min: 0, max: 320, step: 1 },
  bugsPercent: { min: 0, max: 30, step: 1 },
  macCready_ms: { min: 0, max: 5, step: 0.1 },
  windHeadwind_kmh: { min: -40, max: 40, step: 1 },
} as const;

export const DEFAULT_CONFIGURATION: Configuration = {
  gliderId: "asw-27",
  pilotWeight_kg: 85,
  waterBallast_kg: 0,
  bugsPercent: 0,
  macCready_ms: 1.5,
  windHeadwind_kmh: 0,
  units: "metric",
};
